import { Dimensions } from 'react-native';
import DeviceInfo from 'react-native-device-info';
import { t } from '@lingui/macro';
import { get } from 'lodash';

import { i18n } from '@src/i18n';

export const baseURL =
  process.env.REACT_APP_API_URL || 'https://api.youtopin.com';

export const isTablet = DeviceInfo.isTablet();

export const window = Dimensions.get('window');
export const windowWidth = window.width;
export const windowHeight = window.height;
export const maxWidth = 720;
export const maxHeight = 1280;
export const padding = 15;
export const separatorWidth = 10;
export const postNormalHeight = 300;
export const tourCardWidth = 224;
// export const tourCardHeight = 161;
export const journeyCardWidth = 142;
export const journeyCardHeight = 142;
export const shortcutSize = 88;
export const journeyNumColumns = Math.floor(
  windowWidth / (journeyCardWidth + separatorWidth)
);
export const tourSummeryCardWidth = 200;
export const tourSummeryCardHeight = 90;
export const primeBookCardWidth = 150;
export const primeBookCardHeight = 285;
export const primeBookNumColumns = Math.floor(
  windowWidth / (primeBookCardWidth + separatorWidth)
);

export const likeColor = '#D0021B';

const tourBookings = {
  0: {
    color: '#ff1080',
    title: i18n._(t`Expired`),
  },
  1: {
    color: '#d6e11e',
    title: i18n._(t`Limited`),
  },
  2: {
    color: '#ff1080',
    title: i18n._(t`Sold out`),
  },
  3: {
    color: '#ff4576',
    title: i18n._(t`Discount`),
  },
  5: {
    color: '#4c95b7',
    title: i18n._(t`Active`),
  },
};

export const getTourBookings = (booking: number) =>
  get(tourBookings, booking, tourBookings[0]);

interface Item {
  id: string | number;
}

export const idKeyExtractor = (item: Item) => `${item.id}`;
export const indexKeyExtractor = (item: any, index: number) => index.toString();

export const shortTimeout = 2000;
export const activeOpacity = 0.8;
export const avatarSize = 40;
